module.exports = __webpack_public_path__ + "img/ease.8ff26a9.svg";